<template>
  <div
    class="private-ad-select"
    :class="{
      'private-ad-select--open': isOpen,
      'private-ad-select--disabled': isDisabled,
    }"
  >
    <p class="private-ad-select__title">{{ title }}</p>
    <button
      @click.prevent="emitState('private-ad-select-toggle')"
      class="private-ad-select__button"
      type="menu"
    >
      <div class="private-ad-select__text-container">
        <p class="private-ad-select__text">
          <span v-html="title"></span>
          <span class="private-ad-select__selection" v-if="selectionText != ''"
            >(<span v-html="selectionText"></span>)</span
          >
        </p>
      </div>
      <Arrow :direction="isOpen ? 'down' : 'right'" />
    </button>
    <div class="private-ad-select__container">
      <div class="private-ad-select__top-container">
        <button
          v-if="true"
          @click.prevent="emitState('private-ad-select-close')"
          class="private-ad-select__top"
          type="button"
        >
          <Arrow direction="left"></Arrow>
        </button>
        <div v-else class="private-ad-select__placeholder"></div>
        <div class="private-ad-select__top" v-html="title"></div>
        <button
          @click.prevent="emitState('private-ad-select-close')"
          class="private-ad-select__top"
          type="button"
        >
          <div aria-label="Luk" class="icon--plus icon--rotate"></div>
        </button>
      </div>
      <div
        class="private-ad-select__content-container"
        :class="{
          'private-ad-select__content-container--bottom-padding': showOkButton,
        }"
      >
        <SearchList
          :type="type"
          :single-select="singleSelect"
          :search-type="searchType"
          :items="items"
          :is-open="isOpen"
          :event-bus="proxyBus"
        ></SearchList>
        <div v-if="showOkButton" class="private-ad-select__content-bottom">
          <button
            @click.prevent="emitState('private-ad-select-close')"
            class="button button--invert"
          >
            Ok
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mitt from 'mitt'
import Arrow from '@shared/Arrow/Arrow.vue'
import SearchList from '@search/SearchList/SearchList.vue'

import UidMixin from '@shared/uid-mixin.vue'

export default {
  mixins: [UidMixin],
  data() {
    return {
      isOpen: false,
      proxyBus: mitt(),
      selectionText: '',
      isInitialLoad: this.isInitialLoadProp,
    }
  },
  components: {
    Arrow,
    SearchList,
  },
  props: {
    items: {
      default: () => {
        return []
      },
      type: Array,
    },
    title: { default: '', type: String },
    index: { default: null, type: Number },
    eventBus: { default: null, type: Object },
    searchRequest: { default: null, type: Array },
    searchType: { default: null, type: String },
    isDisabled: { default: false, type: Boolean },
    type: { default: 'checkbox', type: String },
    singleSelect: { default: false, type: Boolean },
    showOkButton: { default: false, type: Boolean },
    isUpdate: { default: false, type: Boolean },
    isInitialLoadProp: { default: true, type: Boolean },
  },
  watch: {
    items: {
      handler(arr) {
        if (arr.length == 0) {
          this.selectionText = ''
        } else if (this.isInitialLoad) {
          // find selected and set for first load (mostly edit)
          // criteriaCallback will set it afterwards
          const selectedItem = arr.find(item => {
            return item.selected
          })
          if (selectedItem !== undefined) {
            this.setSelectionText(selectedItem)
            this.eventBus.emit('private-ad-select-selection', {
              item: selectedItem,
              index: this.index,
              overlayRef: this,
            })
          }
          this.isInitialLoad = false
        }
      },
    },
  },
  methods: {
    setSelectionText(options) {
      const selectedCount = this.items.filter(item => {
        return item.selected
      }).length

      if (options.selected && (this.type === 'radio' || this.singleSelect)) {
        if (
          options.summaryOptions !== undefined &&
          options.summaryOptions.length > 0
        ) {
          this.selectionText = options.summaryOptions[0].name
        }
      } else if (selectedCount > 0) {
        this.selectionText = selectedCount.toString()
      } else {
        this.selectionText = ''
      }
    },
    emitState(stateChange) {
      this.eventBus.emit(stateChange, this)
    },
    searchRequestCallback(options) {
      let item = this.items.find(x => x.value == options.value)
      item.selected = options.selected
      this.setSelectionText(options)
      this.eventBus.emit('private-ad-select-selection', {
        item: item,
        index: this.index,
        overlayRef: this,
      })
    },
  },
  created() {
    this.proxyBus.on('search-request-callback', this.searchRequestCallback)
  },
}
</script>

<style lang="scss">
@import 'PrivateAdSelect.scss';
</style>
